import { RootState } from 'store';

export const selectAnnotateStopErrorModal = (state: RootState) =>
  state.modal?.annotateStopErrorModal || { isOpen: false, data: null };
